<template>
  <a-spin :spinning="loading" ref="receiptInfo">
    <a-row :gutter="16" style="margin-left: 5px">
      <a-col :span="8">
        <a-descriptions :column="1">
          <a-descriptions-item>
            <span v-if="refundable" slot="label">{{$t('business.label.returnOrderNo')}}</span>
            <span v-else slot="label">{{$t('business.label.receiptOrderNo')}}</span>
            <a-input-search v-if="editable" v-model="receiptOrder.no" class="orderInfo" @pressEnter="searchByNo" @search="searchByNo"/>
            <span v-else>{{receiptOrder.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.storerName')">
            <span>{{receiptOrder.storer.name}}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions :column="1">
          <a-descriptions-item>
            <span v-if="refundable" slot="label">{{$t('business.label.returnCustomer')}}</span>
            <span v-else slot="label">{{$t('business.label.supplier')}}</span>
            <span>{{data.order.customerName}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="refundable" slot="label">{{$t('business.label.returnType')}}</span>
            <span v-else slot="label">{{$t('business.label.orderType')}}</span>
            <span>{{receiptOrder.orderType.name}}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <!-- 右侧可留空或放置其他信息 -->
        <a-descriptions :column="1">
          <a-descriptions-item :label="$t('business.label.orderStatus')">
            <span>{{orderStatusData.find(item => item.ordinal === data.order.orderStatus)?.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="refundable" slot="label">{{$t('business.label.returnOperator')}}</span>
            <span v-else slot="label">{{$t('business.label.receivingman')}}</span>
            <span v-if="receiptDetail.receivingman">{{receiptDetail.receivingman}}</span>
            <span v-else>{{operator.name}}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
    <a-divider style="margin-top: -12px"/>
    <a-row :gutter="16" style="margin-left: 5px">
      <a-col :span="8">
        <a-descriptions :column="2" style="margin-top: -24px;margin-bottom: -15px">
          <a-descriptions-item :label="$t('business.label.itemNo')" :span="refundable?2:1">
            <a-input-search v-if="editable" ref="itemSearch" v-model="receiptDetail.item.no" :loading="itemSearching" class="detailInfo" @pressEnter="searchByItem" @search="searchByItem"/>
            <span v-else> {{receiptDetail.item.no}} </span>
          </a-descriptions-item>
          <a-descriptions-item v-if="!refundable" :label="$t('business.label.inspection')">
            <a-checkbox :checked="receiptDetail.item.inspection"/>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.itemName')}}</span>
            <span class="normalFont">{{receiptDetail.item.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.quantity')}}</span>
            <a-input-number v-if="editable" ref="receivedQuantityEditor" v-model="receiptDetail.receivedQuantity" :max="data.detail.unreceivedQuantity" :min="0" @change="receivingQuantityChange" @focus="onReceivedQuantityFocus"/>
            <span v-else> {{receiptDetail.receivedQuantity}} </span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.cases')}}</span>
            <a-input-number v-if="editable" v-model="data.detail.boxQuantity" :max="receiptDetail.pack.factor?Math.floor(data.detail.unreceivedQuantity/receiptDetail.pack.factor):0" :min="0" @change="boxQuantityChange"/>
            <span v-else> {{data.detail.boxQuantity}} </span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.numberOfEach')}}</span>
            <span>{{data.detail.eachQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.rejectedQuantity')}}</span>
            <a-input-number v-if="editable" v-model="receiptDetail.rejectedQuantity" :max="data.detail.unreceivedQuantity" :min="0"/>
            <span v-else> {{receiptDetail.rejectedQuantity}} </span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.lot')}}</span>
            <span class="normalFont">{{receiptDetail.lot.no}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.productionDate')}}</span>
            <span class="normalFont">{{isLegal(receiptDetail.lot.productionDate) ? moment(receiptDetail.lot.productionDate).format('YYYY-MM-DD') : null}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="normalFont">{{$t('business.label.validUntil')}}</span>
            <span class="normalFont">{{isLegal(receiptDetail.lot.validUntil) ? moment(receiptDetail.lot.validUntil).format('YYYY-MM-DD') : null}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.approvalNo')}}</span>
            <span class="normalFont">{{receiptDetail.lot.approvalNo}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.producingArea')}}</span>
            <span class="normalFont">{{receiptDetail.lot.producingArea}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="normalFont">{{$t('business.label.manufacturer')}}</span>
            <span class="normalFont">{{receiptDetail.lot.manufacturer}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.inboundStorageRoom')}}</span>
            <a-select v-model="receiptDetail.storageRoom.id" :disabled="!editable" allowClear class="orderInfo">
              <a-select-option v-for="data in storageRoomData" :key="data.id">{{data.name}}{{data.limit === null || data.limit === undefined ? null : '(' + data.limit + ')'}}
              </a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.containerNo')}}</span>
            <a-input-search v-if="editable" v-model="receiptDetail.container.no" class="orderInfo" readOnly @dblclick="()=>this.$refs.containerModal.open()" @pressEnter="()=>this.$refs.containerModal.open()" @search="()=>this.$refs.containerModal.open()"/>
            <span v-else> {{receiptDetail.container.no}} </span>
            <container-modal ref="containerModal" @change="(ctn)=>{receiptDetail.container=ctn.length===0?new Container(): Object.assign(new Container,ctn[0])}"/>
          </a-descriptions-item>
          <a-descriptions-item v-if="refundable" span="2">
            <span slot="label">{{$t('business.label.receiptConclusion')}}</span>
            <a-select class="orderInfo" v-model="receiptDetail.receiptConclusion.id" :disabled="!editable" allowClear>
              <a-select-option v-for="data in receiptConclusionData" :key="data.id">{{data.name}}</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.rejectedReason')}}</span>
            <a-select v-model="receiptDetail.rejectedReason.id" :disabled="receiptDetail.rejectedQuantity===0||!editable" allowClear class="orderInfo">
              <a-select-option v-for="data in rejectedReasonData" :key="data.id">{{data.name}}</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label">{{$t('business.label.treatmentSuggestion')}}</span>
            <a-select v-model="receiptDetail.opinion.id" :disabled="receiptDetail.rejectedQuantity===0 || !editable" allowClear class="orderInfo">
              <a-select-option v-for="data in opinionData" :key="data.id">{{data.name}}</a-select-option>
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions :column="3" style="margin-top: -24px;margin-bottom: -15px">
          <a-descriptions-item :span="storageRoomData.length>1?1:3">
            <span v-if="refundable" slot="label">{{$t('business.label.returnTotalQuantity')}}</span>
            <span v-else slot="label">{{$t('business.label.receiptTotalQuantity')}}</span>
            <span>{{data.detail.totalQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="2" v-if="storageRoomData.length>1">
            <span slot="label">{{$t('business.label.locationLimit')}}</span>
            <a-tooltip :title="getStrings(storageRoomData, 'name')">{{truncateString(getStrings(storageRoomData, 'name'), 18)}}</a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="refundable" slot="label" class="normalFont">{{$t('business.label.unacceptedQuantity')}}</span>
            <span v-else slot="label" class="normalFont">{{$t('business.label.unreceivedQuantity')}}</span>
            <span class="normalFont">{{data.detail.unreceivedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="refundable" slot="label">{{$t('business.label.acceptedQuantity')}}</span>
            <span v-else slot="label">{{$t('business.label.receivedQuantity')}}</span>
            <span>{{data.detail.receivedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="refundable" slot="label">{{$t('business.label.rejectedQuantityOfReturn')}}</span>
            <span v-else slot="label">{{$t('business.label.rejectedQuantity')}}</span>
            <span>{{data.detail.rejectedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.unacceptedQuantity')" v-if="!refundable">
            <span>{{data.detail.unacceptedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.acceptedQuantity')" v-if="!refundable">
            <span>{{data.detail.acceptedQuantity}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.rejectedQuantityOfAcceptance')" v-if="!refundable">
            <span>{{data.detail.rejectedQuantityOfAcceptance}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label" class="normalFont">{{$t('business.label.specification')}}</span>
            <span class="normalFont">{{receiptDetail.pack.specification}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.packagingUnit')}}</span>
            <span>{{receiptDetail.pack.uom}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">{{$t('business.label.factor')}}</span>
            <span>{{receiptDetail.pack.factor}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.innerFactor')">
            <span>{{receiptDetail.pack.innerFactor}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.itemBarcode')" span="3">
            <span>{{receiptDetail.item.barcodes}}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('business.label.qualityStandard')" span="3">
            <span>{{receiptDetail.item.quality}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label">{{$t('business.label.legalAttribute')}}</span>
            <span>{{data.detail.legalAttribute.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label">{{$t('business.label.dosageForm')}}</span>
            <span>{{data.detail.dosageForm.name}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="3">
            <span slot="label">{{$t('business.label.permitHolder')}}</span>
            <span>{{receiptDetail.item.permitHolder}}</span>
          </a-descriptions-item>
          <a-descriptions-item span="1">
            <span slot="label" class="supervisedFont">{{$t('business.label.visualized')}}</span>
            <a-checkbox :checked="receiptDetail.item.visualized"/>
          </a-descriptions-item>
          <a-descriptions-item span="2">
            <span slot="label" class="supervisedFont">{{$t('business.label.scattered')}}</span>
            <a-checkbox :checked="receiptDetail.item.scattered"/>
          </a-descriptions-item>
        </a-descriptions>
        <a-textarea v-model="receiptDetail.notes" :auto-size="{ minRows: 5, maxRows: 7 }" :disabled="!editable" :placeholder="$t('business.label.notes')" style="width: 80%"/>
      </a-col>
      <a-col :span="8">
        <a-card style="width: 100%;">
          <img slot="cover" alt="example" src="@/assets/example.jpeg"/>
          <img slot="cover" alt="example" src="@/assets/example.jpeg"/>
        </a-card>
        <a-descriptions :column="2" style="margin-top: 10px;margin-left: 25%">
          <a-descriptions-item>
            <span v-if="receiptDetail.item.valuable" class="supervisedFont">{{$t('business.label.valuable')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.valuable')}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="receiptDetail.item.special" class="supervisedFont">{{$t('business.label.special')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.special')}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="receiptDetail.item.supervised" class="supervisedFont">{{$t('business.label.supervised')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.supervised')}}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span v-if="receiptDetail.item.fragile" class="supervisedFont">{{$t('business.label.fragile')}}</span>
            <span v-else class="ignoreFont">{{$t('business.label.fragile')}}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
    <ReceiptPickupModal ref="receiptPickupModal" :order-status-data="orderStatusData" :refundable="refundable" :storer-data="storerData" @change="pickUpByAsnOrder"/>
    <ReceiptAsnDetailModal ref="asnDetailModal" :refundable="refundable" @change="pickUpByAsnDetail"/>
    <SupervisedModal ref="supervisedModal" :type="1"/>
    <ReceiptMaintainModal ref="receiptMaintainModal" @success="packSaveSuccess"/>
  </a-spin>
</template>

<script>
import { findAll, findOne, post } from '@/api/Api'
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import ACol from 'ant-design-vue/es/grid/Col'
import ARow from 'ant-design-vue/es/grid/Row'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import ReceiptPickupModal from '@/views/inbound/receipt/modal/ReceiptPickupModal.vue'
import SupervisedModal from '@/views/modal/SupervisedModal.vue'
import ReceiptAsnDetailModal from '@/views/inbound/receipt/modal/ReceiptAsnDetailModal.vue'
import Api from '@/api'
import api from '@/api'
import { ReceiptDetail, ReceiptOrder } from '@/api/dto/order/ReceiptOrder'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'
import { Container } from '@/api/dto/common/Container'
import { Lot } from '@/api/dto/common/Lot'
import ReceiptMaintainModal from '@/views/inbound/receipt/modal/ReceiptMaintainModal.vue'
import { getStrings, isLegal, truncateString } from '@/utils/util'
import { DeviceHandler } from '@/deviceHelper'
import moment from 'moment'

export default {
    name: 'ReceiptEdit',
    computed: {
      moment() {
        return moment
      },
      Container() {
        return Container
      }
    },
    components: {
      ReceiptMaintainModal,
      SupervisedModal,
      ReceiptPickupModal,
      ReceiptAsnDetailModal,
      ContainerModal,
      ARow,
      ACol
    },
    data() {
      return {
        data: {
          order: {
            customerName: null,
            orderStatus: null
          },
          detail: {
            inspection: false,
            boxQuantity: 0,
            eachQuantity: 0,
            packDescription: null,
            stackType: null,
            locationLimit: null,
            totalQuantity: 0,
            receivedQuantity: 0,
            unreceivedQuantity: 0,
            rejectedQuantity: 0,
            acceptedQuantity: 0,
            unacceptedQuantity: 0,
            rejectedQuantityOfAcceptance: 0,
            legalAttribute: new Dictionary(),
            dosageForm: new Dictionary()
          },
          receiptingOrder: null
        },
        receiptOrder: new ReceiptOrder(),
        receiptDetail: new ReceiptDetail(),
        storageRoomData: [],
        receiptConclusionData: [],
        rejectedReasonData: [],
        opinionData: [],
        warehouse: Vue.ls.get(WAREHOUSE),
        operator: Vue.ls.get(OPERATOR),
        loading: false,
        itemSearching: false,
        editable: true
      }
    },
    props: {
      refundable: {
        type: Boolean,
        default: false
      },
      orderStatusData: {
        type: Array,
        default: []
      },
      storerData: {
        type: Array,
        default: []
      }
    },
    mounted() {
      findOne('fieldFactory', { no: 'REJECT_REASON' }).then(res => {
        if (res.success) {
          this.rejectedReasonData = res.result.dictionaries
        }
      })
      findOne('fieldFactory', { no: 'OPINION' }).then(res => {
        if (res.success) {
          this.opinionData = res.result.dictionaries
        }
      })
      if (this.refundable) {
        findOne('fieldFactory', { no: 'RETURN_CONCLUSION' }).then(res => {
          if (res.success) {
            this.receiptConclusionData = res.result.dictionaries
          }
        })
      }
    },
    methods: {
      truncateString,
      isLegal,
      getStrings,
      searchByNo() {
        if (this.receiptOrder.no) {
          const args = {
            no: this.receiptOrder.no,
            extract: true,
            refundable: false
          }
          this.getOrder(args)
        } else {
          this.openOrderPickUp()
        }
      },
      getOrder(args) {
        this.loading = true
        findAll('receivingAsnListFactory', args).then(res => {
          if (res.success) {
            if (res.result.length > 0) {
              let asnOrder = res.result[0].order
              asnOrder.orderType = res.result[0].orderType
              asnOrder.storer = res.result[0].storer
              asnOrder.customer = res.result[0].customer
              this.fetchOrder(asnOrder)
            } else {
              this.$warning({
                title: '未查询到相关单据或该单据已收货结束',
                centered: true,
                okText: '确定'
              })
              this.clear()
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      fetchOrder(asnOrder) {
        this.receiptOrder = new ReceiptOrder(asnOrder)
        this.receiptOrder.id = null
        this.data.order.customerName = asnOrder.customer.name
        this.data.order.orderStatus = asnOrder.orderStatus
        this.data.receiptingOrder = asnOrder
        if (this.receiptDetail.item.no) {
          this.clearDetail()
        }
        this.$nextTick(() => {
          this.$refs.itemSearch.focus()
        })
      },
      searchByItem() {
        if (this.receiptDetail.item.no === null || this.receiptDetail.item.no === undefined || this.receiptDetail.item.no.trim() === '') {
          if (this.receiptOrder.no === null || this.receiptOrder.no === undefined || this.receiptOrder.no.trim() === '') {
            return this.$warning({
              title: '请先输入单号',
              centered: true,
              okText: '确定'
            })
          } else {
            this.itemSearching = true
            findAll('asnDetailFactory', { no: this.receiptOrder.no, aggregate: true }).then(res => {
              if (res.success) {
                this.$refs.asnDetailModal.open(res.result)
              }
            }).finally(() => {
              this.itemSearching = false
            })
          }
        } else {
          this.itemSearching = true
          findAll('asnDetailFactory', { no: this.receiptOrder.no, 'item.no': this.receiptDetail.item.no, aggregate: true }).then(res => {
            if (res.success) {
              const view = res.result
              if (view.length > 0) {
                if (view.length === 1) {
                  this.pickUpByAsnDetail(view[0])
                } else {
                  this.$refs.asnDetailModal.open(view)
                }
              } else {
                this.$warning({
                  title: '未查询到相关商品明细',
                  centered: true,
                  okText: '确定'
                })
              }
            }
          }).finally(() => {
            this.itemSearching = false
          })
        }
      },
      openOrderPickUp() {
        this.$refs.receiptPickupModal.open({ no: this.receiptOrder.no })
      },
      pickUpByAsnOrder(asnOrder) {
        this.fetchOrder(asnOrder)
        this.pickUpByAsnDetail(asnOrder.details[0])
      },
      pickUpByAsnDetail(view) {
        this.loading = true
        this.receiptDetail.asnDetail = view.asnDetail
        this.receiptDetail.item = new Item()
        this.receiptDetail.pack = new Pack()
        Object.assign(this.receiptDetail.item, view.item)
        Object.assign(this.receiptDetail.pack, view.pack)
        const lot = new Lot()
        lot.item = this.receiptDetail.item
        lot.no = view.asnDetail.lotNo
        lot.approvalNo = view.asnDetail.approvalNo
        lot.productionDate = view.asnDetail.productionDate
        lot.validUntil = view.asnDetail.validUntil
        lot.manufacturer = view.asnDetail.manufacturer
        lot.producingArea = view.asnDetail.producingArea
        lot.quality = view.asnDetail.quality
        lot.license = view.asnDetail.license
        lot.permission = view.asnDetail.permission
        lot.practice = view.asnDetail.practice
        this.receiptDetail.lot = lot
        this.data.detail.totalQuantity = view.asnDetail.quantity
        this.data.detail.receivedQuantity = view.asnDetail.receivedQuantity
        this.data.detail.rejectedQuantity = view.asnDetail.rejectedQuantity
        this.data.detail.unreceivedQuantity = view.asnDetail.quantity - view.asnDetail.receivedQuantity - view.asnDetail.rejectedQuantity
        this.data.detail.acceptedQuantity = view.asnDetail.acceptedQuantity
        this.data.detail.rejectedQuantityOfAcceptance = view.asnDetail.rejectedQuantityOfAcceptance
        this.data.detail.unacceptedQuantity = view.asnDetail.receivedQuantity - view.asnDetail.acceptedQuantity - view.asnDetail.rejectedQuantityOfAcceptance
        this.data.detail.dosageForm = view.dosageForm === null || view.dosageForm === undefined ? new Dictionary() : view.dosageForm
        this.data.detail.legalAttribute = view.legalAttribute === null || view.legalAttribute === undefined ? new Dictionary() : view.legalAttribute
        this.data.detail.boxQuantity = 0
        this.data.detail.eachQuantity = 0
        this.receiptDetail.receivedQuantity = 0
        this.receiptDetail.rejectedQuantity = 0
        this.acquireStorageRoom(this.receiptDetail.item.id, this.receiptDetail.pack.id).then(() => {
          this.$nextTick(() => {
            this.$refs.receivedQuantityEditor.focus()
          })
        })
      },
      pickUpByReceiptDetail(view) {
        this.loading = true
        this.editable = view.detail.acceptedQuantity + view.detail.rejectedQuantityOfAcceptance === 0
        const order = {
          id: view.order.id,
          no: view.order.no,
          dataSource: view.order.dataSource,
          orderType: view.orderType,
          storer: view.storer,
          customer: view.customer,
          orderStatus: view.order.orderStatus,
          version: view.order.version
        }
        this.receiptOrder = new ReceiptOrder(order)
        const detail = {
          id: view.detail.id,
          item: view.item,
          pack: view.pack,
          lot: view.lot,
          container: view.container,
          storageRoom: view.storageRoom,
          receiptConclusion: view.receiptConclusion,
          rejectedReason: view.rejectedReason,
          opinion: view.opinion,
          rejectedReasonOfAcceptance: view.rejectedReasonOfAcceptance,
          opinionOfAcceptance: view.opinionOfAcceptance,
          receivingman: view.detail.receivingman,
          invoiceQuantity: view.detail.invoiceQuantity,
          receivedQuantity: view.detail.receivedQuantity,
          rejectedQuantity: view.detail.rejectedQuantity,
          rejectedQuantityOfAcceptance: view.detail.rejectedQuantityOfAcceptance,
          notes: view.detail.notes,
          asnDetail: view.asnDetail,
          asnOrder: view.asnOrder,
          version: view.detail.version
        }
        const asnDetail = view.asnDetail
        this.data.receiptingOrder = view.asnOrder
        this.data.order.customerName = order.customer.name
        this.data.order.orderStatus = order.orderStatus
        this.data.detail.totalQuantity = asnDetail.quantity
        this.data.detail.receivedQuantity = asnDetail.receivedQuantity
        this.data.detail.rejectedQuantity = asnDetail.rejectedQuantity
        this.data.detail.unreceivedQuantity = asnDetail.quantity - asnDetail.receivedQuantity - asnDetail.rejectedQuantity
        this.data.detail.acceptedQuantity = asnDetail.acceptedQuantity
        this.data.detail.rejectedQuantityOfAcceptance = asnDetail.rejectedQuantityOfAcceptance
        this.data.detail.unacceptedQuantity = asnDetail.receivedQuantity - asnDetail.acceptedQuantity - asnDetail.rejectedQuantityOfAcceptance
        this.data.detail.dosageForm = detail.item.dosageForm === null || detail.item.dosageForm === undefined ? new Dictionary() : detail.item.dosageForm
        this.data.detail.legalAttribute = detail.item.legalAttribute === null || detail.item.legalAttribute === undefined ? new Dictionary() : detail.item.legalAttribute
        this.data.detail.boxQuantity = Math.floor(detail.receivedQuantity / detail.pack.factor)
        this.data.detail.eachQuantity = detail.receivedQuantity % detail.pack.factor
        if (this.editable) {
          this.acquireStorageRoom(detail.item.id, detail.pack.id).then(() => {
            this.receiptDetail = new ReceiptDetail(detail)
            this.$nextTick(() => {
              this.$refs.receivedQuantityEditor.focus()
            })
          })
        } else {
          this.storageRoomData = [detail.storageRoom]
          this.receiptDetail = new ReceiptDetail(detail)
          this.loading = false
        }
      },
      acquireStorageRoom(itemId, packId) {
        return new Promise((resolve) => {
          if (itemId === '' || itemId === null || itemId === undefined) {
            this.$warning({ title: '未获取到商品信息,加载失败', centered: true })
            return resolve()
          }
          const args = {
            'query.no': 'limitStorageRoom',
            'sql': null,
            args: { whId: this.warehouse.id, itemId: itemId }
          }
          post(Api.adminQuery, {}, args).then(res => {
            if (res.success) {
              this.storageRoomData = res.result
              this.packVerify(this.storageRoomData, packId)
            }
          }).finally(() => {
            this.loading = false
            resolve()
          })
        })
      },
      onReceivedQuantityFocus(e) {
        e.target.select()
      },
      receivingQuantityChange() {
        if (this.receiptDetail.pack.factor) {
          this.data.detail.boxQuantity = Math.floor(this.receiptDetail.receivedQuantity / this.receiptDetail.pack.factor)
          this.data.detail.eachQuantity = this.receiptDetail.receivedQuantity % this.receiptDetail.pack.factor
        }
      },
      boxQuantityChange() {
        if (this.receiptDetail.pack.factor) {
          this.receiptDetail.receivedQuantity = this.data.detail.boxQuantity * this.receiptDetail.pack.factor
          this.data.detail.eachQuantity = 0
        }
      },
      clearOrder() {
        this.receiptOrder = new ReceiptOrder()
        this.data.order = {
          customerName: null,
          orderStatus: null
        }
      },
      clearDetail() {
        this.receiptDetail = new ReceiptDetail()
        this.data.detail = {
          inspection: false,
          receivedCase: 0,
          eachQuantity: 0,
          packDescription: null,
          stackType: null,
          locationLimit: null,
          totalQuantity: 0,
          receivedQuantity: 0,
          unreceivedQuantity: 0,
          rejectedQuantity: 0,
          acceptedQuantity: 0,
          unAcceptedQuantity: 0,
          rejectedQuantityOfAcceptance: 0,
          legalAttribute: new Dictionary(),
          dosageForm: new Dictionary()
        }
        this.storageRoomData = []
      },
      clear() {
        this.clearOrder()
        this.clearDetail()
        this.data.receiptingOrder = null
        this.editable = true
      },
      openSupervisedModal() {
        if (this.receiptOrder.no && this.receiptDetail.lot.no) {
          const args = {
            'order.no': this.receiptOrder.no,
            'item.no': this.receiptDetail.item.no,
            'lot.no': this.receiptDetail.lot.no
          }
          this.$refs.supervisedModal.open(args)
        } else {
          this.$warning({
            title: '请先确定需要采集的单据及商品信息',
            centered: true,
            okText: '确定'
          })
        }
      },
      saveReceipt() {
        if (this.receiptOrder.storer.isNew()) {
          return this.$warning({
            title: '缺少单据信息',
            centered: true,
            okText: '确定'
          })
        }
        if (!this.receiptOrder.receivingman) this.receiptOrder.receivingman = this.operator.name
        if (this.receiptDetail.item.isNew()) {
          return this.$warning({
            title: '缺少商品信息',
            centered: true,
            okText: '确定'
          })
        }
        if (this.receiptDetail.receivedQuantity === 0 && this.receiptDetail.rejectedQuantity === 0) {
          return this.$warning({
            title: '数量与拒收数量不能同时为0',
            centered: true,
            okText: '确定'
          })
        }
        if (this.receiptDetail.rejectedQuantity > 0 && this.receiptDetail.rejectedReason.isNew()) {
          return this.$warning({
            title: '拒收数量大于0,请填写拒收原因',
            centered: true,
            okText: '确定'
          })
        }
        this.$emit('saveStart')
        this.loading = true
        const saveData = {
          allocate: true,
          tag: false,
          order: {
            ...this.receiptOrder.toJSONObject(),
            warehouse: this.warehouse,
            asnOrder: this.data.receiptingOrder,
            notes: this.receiptDetail.notes,
            details: [{
              id: this.receiptDetail.id,
              invoiceQuantity: this.receiptDetail.receivedQuantity,
              receivedQuantity: this.receiptDetail.receivedQuantity,
              rejectedQuantity: this.receiptDetail.rejectedQuantity,
              item: this.receiptDetail.item,
              lot: this.receiptDetail.lot,
              pack: this.receiptDetail.pack,
              receivingman: this.operator.name,
              container: this.receiptDetail.container.skipNulls(),
              storageRoom: this.receiptDetail.storageRoom.skipNulls(),
              receiptConclusion: this.refundable ? this.receiptDetail.receiptConclusion.skipNulls() : null,
              rejectedReason: this.receiptDetail.rejectedReason.skipNulls(),
              opinion: this.receiptDetail.opinion.skipNulls(),
              notes: this.receiptDetail.notes,
              asnOrder: this.data.receiptingOrder,
              asnDetail: this.receiptDetail.asnDetail,
              version: this.receiptDetail.version
            }]
          }
        }
        post(Api.receivingReceiverSave, { type: 'normalInboundReceiver' }, saveData).then(res => {
          if (res.success) {
            const that = this
            if (this.receiptOrder.id !== null && this.receiptOrder.id !== undefined) {
              this.$emit('editDetailSuccess')
            }
            this.printData(res.result)
            this.$success({
              title: '保存成功',
              onOk() {
                that.superviseVerify()
                that.searchByNo()
                // let saveSuccessData = res.result
                // this.printData(saveSuccessData)
              },
              onCancel() {
                that.superviseVerify()
                that.searchByNo()
              },
              centered: true
            })
          }
        }).finally(() => {
          this.$emit('saveFinish')
          this.loading = false
        })
      },
      superviseVerify() {
        if (this.receiptDetail.item.supervised) {
          this.openSupervisedModal()
        }
      },
      packVerify(locationLimits, packId) {
        if (packId === null || packId === undefined) {
          return this.$warning({
            title: '获取包装信息失败',
            content: '请重新提取单据或联系技术人员',
            okText: '确定',
            centered: true
          })
        }
        findOne('packFactory', { id: packId }).then(res => {
          if (res.success) {
            let pack = res.result
            if ((pack.dimension.width === 0 && pack.dimension.length === 0 && pack.dimension.height === 0) || locationLimits.length <= 1) {
              const that = this
              this.$confirm({
                title: '检测到包装资料或货位限定未维护',
                content: '是否打开资料维护',
                onOk() {
                  that.openReceiptMaintain()
                },
                okText: '确定',
                centered: true
              })
            }
          } else {
            this.$warning({
              title: '获取包装信息失败',
              content: '请重新提取单据或联系技术人员',
              okText: '确定',
              centered: true
            })
          }
        })
      },
      openReceiptMaintain() {
        if (this.receiptOrder.no !== null && this.receiptOrder.no !== undefined && this.receiptOrder.no !== '') {
          const receiptDetail = {
            item: this.receiptDetail.item,
            storer: this.receiptOrder.storer,
            pack: this.receiptDetail.pack,
            locationLimits: this.storageRoomData
          }
          this.$refs.receiptMaintainModal.open(receiptDetail)
        } else {
          this.$message.warning('请先确定需要维护的单据及商品信息')
        }
      },
      packSaveSuccess(pack) {
        this.receiptDetail.pack = pack
      },
      print() {
        this.$print(this.$refs.receiptInfo)
      },
      printData(data) {
        if (data.commandGroup === null || data.commandGroup === undefined) {
          return
        }
        const body1 = {
          'query.no': 'receivingCheckPrint',
          sql: null,
          args: {
            commandGroup: data.commandGroup
          }
        }
        post(api.adminQuery, {}, body1).then(res => {
          if (res.result.length > 0) {
            const Dt = []
            res.result.map(data => {
              data.zhxs = '入(' + parseInt(data.zhjs).toFixed(1) + '箱)'
              data.spmcgg = data.spmc + ' / ' + data.gg
              data.phxq = data.ph + ' / ' + data.xq
              data.sldw = '数量：' + data.sl + '(' + data.dw + ')'
              data.qyxx = data.qy + ' / ' + data.lc + data.zs + ' / ' + data.spbh
              data.dhrq = data.asnNo + ' / ' + data.scrq
              data.bdm = data.pzwh + '箱数量：' + parseInt(data.bzs).toFixed(1) + ' / ' + data.fdsx
              Dt.push(data)
            })
            if (Dt.length > 0) {
              const printList = []
              printList.push(
                {
                  'PLAN_CODE': '080027',
                  'WH_ID': 1000000001,
                  'DATA': Dt
                }
              )
              DeviceHandler.printWithDataList(printList, (q, res) => {
                post(api.receivingReceiverPrintUpdate, {}, { commandGroup: data.commandGroup })
              })
            }
          } else {
            this.$message.warning('无可打印数据')
          }
        })
      }
    }
  }
</script>

<style scoped>
  .ant-row {
    margin: 16px 0;
  }
  
  .ant-col {
    padding: 0 12px;
  }

  .orderInfo {
    width: 300px;
    margin-bottom: 8px;
  }

  .detailInfo {
    width: 150px;
  }

  .normalFont {
    font-weight: bold;
    color: #404040;
  }

  .supervisedFont {
    font-weight: bold;
    font-size: 22px;
    color: red;
  }

  .ignoreFont {
    font-weight: bold;
    font-size: 22px;
    color: #837D7DFF;
  }

  .highlight-quantity {
    font-weight: bold;
    color: #1890ff;
  }
  
  .warning-quantity {
    font-weight: bold;
    color: #faad14;
  }

  .ant-card {
    margin-bottom: 16px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }

  .attribute-tag {
    display: inline-block;
    padding: 4px 8px;
    margin: 4px;
    border-radius: 4px;
    font-weight: bold;
  }
  
  .attribute-tag.supervised {
    background: #fff2f0;
    border: 1px solid #ffccc7;
  }
  
  .attribute-tag.valuable {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
  }

  @media (max-width: 1200px) {
    .ant-col {
      padding: 0 8px;
    }
    
    .orderInfo {
      width: 250px;
    }
  }
</style>